const API_RESPONSE_MESSAGES = {
  MESSAGE_ER_DUP_ENTRY: 'ER_DUP_ENTRY',
};
export default API_RESPONSE_MESSAGES;
